import { css, keyframes } from 'styled-components'

/** Slower, softer shimmer — avoids the “flickery / broken app” feel of fast 1.5s linear pulses. */
export const inboxSkeletonShimmer = keyframes`
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
`

export const inboxSkeletonSurface = css`
    background: linear-gradient(
        90deg,
        #f1f3f6 0%,
        #f1f3f6 38%,
        #e6eaf0 50%,
        #f1f3f6 62%,
        #f1f3f6 100%
    );
    background-size: 400% 100%;
    animation: ${inboxSkeletonShimmer} 2.8s ease-in-out infinite;
`

export const inboxContentFadeIn = keyframes`
    from { opacity: 0; }
    to { opacity: 1; }
`

export const inboxContentReveal = css`
    animation: ${inboxContentFadeIn} 320ms ease-out both;
`
